module.exports = __webpack_public_path__ + "media/images/mypage/icon/green/ico_user-3e3442bb84b22cc60170a9a8059c8f6e.svg";